import React from "react";
import { connect } from "react-redux";
import SalaryDeductionTable from "./components/SalaryDeductionTable";
import UploadButton from "components/button/upload";
import DownloadButton from "components/button/download";

const SalaryDeductions = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<SalaryDeductionTable/>
	      	
	      	<div className="btn-container">
	      		<DownloadButton downloadPath="salary-deductions" title="Download" filters={filters}/>
	      		<UploadButton uploadPath='salary-deductions' title="Upload"/>
	      	</div>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	filters: state.salaryAdjustment.salaryAdjustmentList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryDeductions);